import React, { createContext, useContext, useState } from 'react';

// Selezione zone (regioni/province) condivisa tra Dashboard e Header (aree salvate).
const Ctx = createContext(null);

export function DashboardSelectionProvider({ children }) {
  const [selRegions, setSelRegions] = useState(new Set());
  const [selProvinces, setSelProvinces] = useState(new Set());
  return (
    <Ctx.Provider value={{ selRegions, setSelRegions, selProvinces, setSelProvinces }}>
      {children}
    </Ctx.Provider>
  );
}

export function useDashboardSelection() {
  return useContext(Ctx);
}
